import { useLocation } from 'react-router-dom';
import { useAuth } from '../../context/AuthContext';
import { useExperience } from '../ExperienceProvider';
import { useNextAction } from './useNextAction';
import { resolveFlowModel } from '../lib/flowModel';
import { parentMapTLA } from '../config/parentMap.tla';
import { resolveDashboardPath } from '../config/resolveDashboardPath.tla';

// Composes the FlowBar model from route + auth + in-app history + read-only next action.
export function useFlowBar() {
  const { pathname } = useLocation();
  const { isAuthenticated, isAdmin, isOwner } = useAuth();
  const auth = { isAuthenticated, isAdmin, isOwner };
  const { history } = useExperience();
  const nextAction = useNextAction(auth);

  return resolveFlowModel({
    pathname,
    history,
    auth,
    nextAction,
    parentMap: parentMapTLA,
    resolveDashboardPath,
  });
}
